module.exports = __webpack_public_path__ + "static/img/icon_6.1aa689d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_6.png
// module id = 8BbU
// module chunks = 0